<script lang="ts">
	import type { CustomBlockComponentProps } from '@portabletext/svelte';
	import { slugify } from 'utils/learn/generateTree';

	export let portableText: CustomBlockComponentProps<{
		style: string;
		children: { text: string }[];
	}>;
</script>

<svelte:element
	this={portableText.value.style}
	id={`${slugify(portableText.value.children[0].text)}`}
>
	<slot />
</svelte:element>
